import React from 'react';
import TopupRowProperties from "./TopupRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import TopupRowMedium from "./TopupRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import TopupRowSmall from "./TopupRowSmall";


const TopupRow: React.FC<TopupRowProperties> = ({
                                                    topup,
                                                    products = [],
                                                    filter,
                                                    selected,
                                                    onTopupSelect,
                                                    onLoad,
                                                    from,
                                                    to,
                                                }) => {
    return (
        <>
            <ViewSmall>
                <TopupRowSmall
                    topup={topup}
                    products={products}
                    filter={filter}
                    selected={selected}
                    onTopupSelect={onTopupSelect}
                    onLoad={onLoad}
                    from={from}
                    to={to}
                />
            </ViewSmall>
            <ViewMedium>
                <TopupRowMedium
                    topup={topup}
                    products={products}
                    filter={filter}
                    selected={selected}
                    onTopupSelect={onTopupSelect}
                    onLoad={onLoad}
                    from={from}
                    to={to}
                />
            </ViewMedium>
            <ViewLarge>
                <TopupRowMedium
                    topup={topup}
                    products={products}
                    filter={filter}
                    selected={selected}
                    onTopupSelect={onTopupSelect}
                    onLoad={onLoad}
                    from={from}
                    to={to}
                />
            </ViewLarge>
        </>
    )
}

export default TopupRow;
